<template>
  <div>
    <EquipmentImportantButton
      :has-dropdown="!disabled"
      :selected="isEnabled"
      :disabled="disabled"
    />
    <div class="stock dropdown-menu" v-if="!disabled">
      <div class="trims-imported-container">
        <span
          class="trims-imported"
          :data-message="$t('components/equipments.stock.important_dropdown.imported')"
        />
        <div role="separator" class="dropdown-divider"></div>
      </div>

      <label for="equipments[]" class="w-100 stock-equipment-checkbox assigned">
        <span :class="['check-width', isEnabled ? 'check' : '']"></span>
        <a href="#" @click.prevent="$emit('enable')">
          {{ $t('components/equipments.stock.important_dropdown.enable') }}
        </a>
      </label>

      <label :class="['w-100 stock-equipment-checkbox disable']" for="disableEquipment[]">
        <span :class="['check-width', !isEnabled ? 'check' : '']"></span>
        <a href="#" @click.prevent="$emit('disable')">
          {{ $t('components/equipments.stock.important_dropdown.disable') }}
        </a>
      </label>
    </div>
  </div>
</template>

<script>
import EquipmentImportantButton from '@components/equipment/EquipmentImportantButton.vue'

export default {
  name: 'EquipmentImportantDropdown',
  components: {
    EquipmentImportantButton
  },
  emits: ['enable', 'disable'],
  props: {
    important: {
      type: Boolean,
      default: false
    },
    overrideImportant: {
      type: Boolean,
      default: false
    },
    importantInTrim: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEnabled() {
      return (
        (!this.overrideImportant && this.importantInTrim) ||
        (this.overrideImportant && this.important)
      )
    }
  }
}
</script>
